export default function signupImage() {
  const widgetName = 'signupImage';
  const widgetOpts = signupImageOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: [''],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: false,
    maxItemsVisible: 1,
    itemsPerPanel: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      $(`.${widgetName} .card-widget-item`).remove();
      if (!hasData) {
        $widget.remove();
      }
    },
  });
}
